import { loyaltyApiDetail, translateLoyaltyApiMessage } from "../../utils/loyaltyApiMessage";

export function segmentErrorMessage(status, detail, fallbackPrefix = "Erreur", context = null) {
    const raw = loyaltyApiDetail(detail);
    const text = (raw || "").toLowerCase();

    const translated = translateLoyaltyApiMessage(detail);
    if (translated) return translated;

    if (status === 400) {
        if (context === "refresh" || text.includes("refresh")) {
            if (text.includes("unomi") || text.includes("recompute")) {
                return "Impossible de recalculer ce segment depuis l'admin : en mode Unomi / CDP only, les membres sont évalués dans le CDP. Le backend doit synchroniser la liste (voir SEGMENTS_FRONTEND.md).";
            }
            if (text.includes("dynamic") && text.includes("member")) {
                return "Le recalcul des membres n'est pas disponible pour ce segment dynamique Unomi / CDP.";
            }
        }
        if (text.includes("dynamic") && text.includes("member")) {
            if (context === "add" || context === "remove") {
                return "Ce segment est dynamique : la gestion manuelle des membres est interdite.";
            }
            return raw
                ? `Requête refusée : ${raw}`
                : "Ce segment est dynamique : la gestion manuelle des membres est interdite.";
        }
        if (text.includes("recompute") && text.includes("static")) {
            return "Le recalcul ne s'applique qu'aux segments dynamiques.";
        }
        if (text.includes("recompute") && (text.includes("unomi") || text.includes("provider"))) {
            return "Le recalcul moteur (recompute / refresh) n'est pas supporté pour ce segment Unomi. Utiliser la synchro membership depuis le CDP côté backend.";
        }
        if (text.includes("condition") && text.includes("static")) {
            return "Un segment statique ne peut pas contenir de conditions.";
        }
        if (text.includes("condition") && (text.includes("invalid") || text.includes("required"))) {
            return "Les conditions du segment sont invalides ou incomplètes. Vérifiez le builder ou le JSON Unomi.";
        }
        if (text.includes("unomi") && text.includes("condition")) {
            return "Condition Unomi invalide. Vérifiez le JSON ou contactez l'équipe CDP.";
        }
        if (raw) {
            return raw;
        }
        return `${fallbackPrefix} : données invalides. Vérifiez les champs saisis.`;
    }

    if (status === 409) {
        if (text.includes("name") && (text.includes("already") || text.includes("duplicate"))) {
            return "Un segment portant ce nom existe déjà pour cette marque. Choisissez un autre nom.";
        }
        if (text.includes("already") || text.includes("déjà") || text.includes("deja")) {
            if (context === "add" || text.includes("member")) {
                return "Ce client est déjà membre de ce segment.";
            }
            return "Conflit : l'opération entre en conflit avec l'état actuel. Vérifiez les données puis réessayez.";
        }
        if (text.includes("referenc") || text.includes("rule") || text.includes("job")) {
            return "Ce segment est encore référencé par des règles ou des jobs. Retirez-le de ces configurations avant de continuer.";
        }
        if (raw) return raw;
        return "Conflit (409) : vérifiez les références et réessayez.";
    }

    if (status === 502) {
        return "Erreur CDP Unomi (502) : synchronisation impossible. Réessayez ou utilisez « Resync Unomi ».";
    }

    if (raw) return raw;
    return `${fallbackPrefix} (HTTP ${status || "inconnu"})`;
}

export default segmentErrorMessage;
